import { render, staticRenderFns } from "./p03.vue?vue&type=template&id=2cd1ccd7&scoped=true&"
import script from "./p03.vue?vue&type=script&lang=js&"
export * from "./p03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1ccd7",
  null
  
)

export default component.exports